import React from 'react';
//CSS
import styles from './ProgressSection.module.css';
import ProgressBar from '../ProgressBar/ProgressBar';
import { ProgressSegmentData } from '../ProgressBar/ProgressSegmentData';
//Components
//Data

type ProgressSectionProps = {
    title: string;
    itemName: string;
    percentage?: number;
    segments?: ProgressSegmentData[];
    animate?: boolean;
    completedCount?: number;
    totalCount?: number;
};

const ProgressSection = ({ title, itemName, percentage, segments, animate, completedCount, totalCount } : ProgressSectionProps) => {

  return (
    <div className={styles.container}>
        <div className={styles.progressTitle}>
            <p className={styles.progressTitleText}>Progress against completion of {itemName}</p>
            {completedCount !== undefined && totalCount !== undefined &&
                <p className={styles.progressTotal}>{completedCount} of {totalCount} {itemName} completed</p>
            }
        </div>

        <ProgressBar percentage={percentage} segments={segments} animate={animate}/>
    </div>
  );
};

export default ProgressSection;